import { Button, Chip } from "@mui/material";
// import { Badge, Box } from "@mui/material";
import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import { useParams } from "react-router-dom";
import CustomDataGridV2 from "../../../../../../../../components/CustomDataGridV2";
import Flex from "../../../../../../../../components/Flex";
import PdfViewDrawer from "../../../../../../../../components/PdfViewDrawer";
import RenderWithTooltip from "../../../../../../../../components/RenderWithTooltip";
import StyledDialog from "../../../../../../../../components/StyledDialog";
import Text from "../../../../../../../../components/Text";
// import ActionMenu from "../../../../../../../../components/app/ActionMenu";
import DeleteModal, {
  useDeleteDisClosure,
} from "../../../../../../../../components/app/DeleteModal";
import ChartTableWrapper from "../../../../../../../../components/app/provider/patient/add-new-patient/ChartTableWrapper";
// import { useRoleController } from "../../../../../../../../components/useRoleController";
import useCurrentUser from "../../../../../../../../hooks/local-storage/use-current-user";
import { DisclosureHost } from "../../../../../../../../hooks/use-disclosure";
import { useReduceDisclosure } from "../../../../../../../../hooks/use-reduce-disclosure";
import { useArchiveOrder } from "../../../../../../../../queries/patient-chart/order/use-archive-order";
import { usePatientPortalOrdersHealthRecord } from "../../../../../../../../queries/patient-chart/order/use-get-patient-portal-orders";
// import { useOrderReportDownload } from "../../../../../../../../queries/patient-chart/order/use-order-report-download";
import {
  // NonNullableDate,
  formatDateTime,
} from "../../../../../../../../utils/date-time-utility";
import {
  // DEFAULT_UUID_NAME_LIST,
  // DEFAULT_VALUE_LABEL_LIST,
  DEF_PAGINATION,
  DGT_Pagination,
  applyDefaultColumnSettings,
  filterActionCol,
  getFormattedId,
  getSuccessSnackbar,
  getXtenantId,
  replaceUnderScoreAddSpace,
  // roleFilter,
  // transformMultiSelectFrontEndVal,
} from "../../../../../../../../utils/utils";
import UpsertLabRequisitionForm from "../../../../../scheduling/appointment/encounter/default-forms/UpsertLabRequisitionForm";
import { usePatientOrderStatusUpdate } from "../../../../../../../../queries/patient-chart/order/use-patient-order-status-update";
import { useSnackbar } from "../../../../../../../../hooks/useSnackbar";
import UpsertResult from "../result/UpsertResultNew";
// import { getStatusOptions } from "../order-utilsnew";
import PrintOrders from "./PrintOrders";
import { getStoredRealm } from "@/utils/auth-storage";

const PatientOrderNewHealthV2 = () => {
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [, setGridSorting] = useState<GridSortItem[]>([]);
  const { mutateAsync: archiveOrder } = useArchiveOrder();
  const deleteOrderDisc = useDeleteDisClosure();
  const showSnackbar = useSnackbar();
  const { patientId } = useParams();
  const [currentUser] = useCurrentUser();
  const patientUuid = patientId || currentUser?.uuid;
  const [
    previewResultDisc,
    orderDisc,
    showMoreDocDisc,
    changeStatusDisc,
    labResult,
    orderPrintViewDisclosure,
  ] = useReduceDisclosure(6);
  // const { hasView } = useRoleController("Imaging order");
  // const { mutateAsync: downloadOrderReport } = useOrderReportDownload();
  const { mutateAsync: changeStatus } = usePatientOrderStatusUpdate();

  const { data: orders, refetch } = usePatientPortalOrdersHealthRecord({
    patientUuid: patientUuid ?? "",
    pagination,
    xTENANTID: getXtenantId() ?? undefined,
  });

  // const getOrderPrint = async (orderId: string) => {
  //   orderPrintViewDisclosure.open(orderId);
  // };

  const DOCUMENT_LABEL_MAP: Record<string, string> = {
    LAB: "Lab Order Report",
    IMAGING: "Imaging Order Report",
  };

  const COLUMNS = applyDefaultColumnSettings<any>(
    [
      {
        field: "uuid",
        headerName: "Order ID",
        flex: 0.3,
        width: 100,
        renderCell: ({ row }) => {
          return <Text isTabletext>{getFormattedId(row?.uuid)}</Text>;
        },
      },
      {
        field: "orderType",
        headerName: "Order Type",
        flex: 0.3,
        minWidth: 100,
        renderCell: ({ value }) =>
          value ? replaceUnderScoreAddSpace(value?.toLowerCase()) : "-",
      },
      {
        field: "orderFormType",
        headerName: "Order Mode",
        flex: 0.3,
        minWidth: 120,
        renderCell: ({ value }) =>
          value ? replaceUnderScoreAddSpace(value?.toLowerCase()) : "-",
      },
      {
        field: "collection_date_time",
        headerName: "Ordered On",
        flex: 0.5,
        width: 180,
        renderCell: ({ row }) =>
          row?.collectionDateTime
            ? formatDateTime(row?.collectionDateTime)
            : "-",
      },
      {
        field: "labOrImagingName",
        headerName: "Imaging/Laboratory Name",
        flex: 0.5,
        width: 180,
        renderCell: ({ row }) =>
          row?.labOrImagingName ? row?.labOrImagingName : "-",
      },
      {
        field: "orderTitle",
        headerName: "Order Title",
        flex: 0.6,
        width: 200,
        renderCell: ({ value }) => <RenderWithTooltip value={value} />,
      },
      {
        field: "labResults",
        headerName: "Documents",
        flex: 0.5,
        width: 180,
        renderCell: ({ row }) => {
          const label =
            DOCUMENT_LABEL_MAP[row?.orderType?.toUpperCase()] || "Order Report";
          const docs = row?.labResults;
          if (docs?.length > 0) {
            return (
              <Text
                isTabletext
                sx={{ cursor: "pointer" }}
                color={"primary.main"}
                fontWeight={"medium"}
                onClick={() =>
                  docs?.length === 1
                    ? previewResultDisc.open(docs[0]?.labDocument)
                    : showMoreDocDisc.open(docs)
                }
              >
                {label}
              </Text>
            );
          }
          return "-";
        },
      },
      {
        field: "userName",
        headerName: "Provider",
        flex: 0.5,
        width: 160,
        renderCell: ({ value }) =>
          value ? <RenderWithTooltip value={value} /> : "-",
      },
      {
        field: "orderStatus",
        headerName: "Status",
        flex: 0.3,
        width: 100,
        renderCell: ({ row }) => {
          const status = row?.orderStatus;
          if (!status) return "-";
          return (
            <Chip
              size="small"
              label={status}
              sx={{
                color: "#00B917",
                backgroundColor: "#E1FCDE",
                fontWeight: 500,
                height: "26px",
              }}
            />
          );
        },
      },
      // {
      //   field: "appointmentDate",
      //   headerName: "Appointment",
      //   flex: 0.8,
      //   width: 200,
      //   renderCell: ({ row }) =>
      //     row?.appointmentDate ? (
      //       <Flex gap={1} flexDirection={"column"}>
      //         <Text>{getFormattedId(row?.appointmentId)}</Text>
      //         <Text>{formatDateTime(row?.appointmentDate)}</Text>
      //       </Flex>
      //     ) : (
      //       "-"
      //     ),
      // },
      // {
      //   field: "labInstruction",
      //   headerName: "Description",
      //   flex: 0.5,
      //   width: 160,
      //   renderCell: ({ value }) => (
      //     <RenderWithTooltip value={value} />
      //   ),
      // },
      // {
      //   field: "Action",
      //   width: 90,
      //   align: "center",
      //   headerAlign: "center",
      //   hideSortIcons: true,
      //   renderCell: ({ row }) => {
      //     return (
      //       <ActionMenu
      //         options={roleFilter({
      //           list: [
      //             { value: "edit", label: "Edit" },
      //             { value: "view", label: "View & Download Report" },
      //             { value: "delete", label: "Delete" },
      //             { value: "addResult", label: "Add Result" },
      //             ...getStatusOptions(row?.orderStatus),
      //           ],
      //           compWith: { view: hasView },
      //         })}
      //         onActionClick={(v) => {
      //           if (v === "edit") {
      //             const transformedData = {
      //               ...row,
      //               location: transformMultiSelectFrontEndVal(
      //                 DEFAULT_UUID_NAME_LIST,
      //                 row?.location
      //               ),
      //               labs: transformMultiSelectFrontEndVal(
      //                 DEFAULT_VALUE_LABEL_LIST,
      //                 row?.labs
      //               ),
      //               tests: transformMultiSelectFrontEndVal(
      //                 DEFAULT_UUID_NAME_LIST,
      //                 row?.tests
      //               ),
      //               medicalCodes: transformMultiSelectFrontEndVal(
      //                 DEFAULT_UUID_NAME_LIST,
      //                 row?.medicalCodes
      //               ),
      //               primaryProvider: row?.primaryProvider
      //                 ? Object.keys(row.primaryProvider)[0]
      //                 : undefined,
      //               orderingProvider: row?.primaryProvider
      //                 ? Object.keys(row.primaryProvider)[0]
      //                 : undefined,
      //             };
      //             orderDisc.open(transformedData);
      //             return;
      //           }
      //           if (v === "view") {
      //             getOrderPrint(row?.uuid);
      //           } else if (v === "delete") deleteOrderDisc.open(row?.uuid);
      //           else if (v === "addResult") {
      //             const initialValues = {
      //               file: undefined,
      //               labDescription: "",
      //               recordedDate: undefined,
      //               abnormalFlag: undefined,
      //               note: "",
      //               resultValue: "",
      //               patientOrderId: {
      //                 value: row?.uuid,
      //                 label: row?.orderTitle,
      //               },
      //             };
      //             labResult.open(initialValues);
      //           } else
      //             changeStatusDisc.open({
      //               patientOrderId: row?.uuid,
      //               status: v,
      //             });
      //         }}
      //       />
      //     );
      //   },
      // },
    ],
    ["collection_date_time"]
  );
  async function archiveHandler<T>(value: boolean, id: T) {
    const res = await archiveOrder({
      patientOrderId: id?.toString() ?? "",
      status: value,
      xTENANTID: getStoredRealm() ?? undefined,
    });
    refetch();
    return res;
  }

  async function changeStatusHandler(uuid: string, status: string) {
    const res = await changeStatus({
      patientOrderId: uuid,
      status: status,
      xTENANTID: getXtenantId() ?? undefined,
    });
    refetch();
    changeStatusDisc.close();
    return res;
  }

  const isVisitNotePage = window.location.pathname.includes("/visit-note");

  return (
    <>
      <UpsertResult disclosureHost={labResult} />
      {orderPrintViewDisclosure.data && (
        <PrintOrders disclosureHost={orderPrintViewDisclosure} />
      )}

      <DeleteModal
        w="380px"
        open={deleteOrderDisc.opened}
        onClose={deleteOrderDisc.close}
        id={deleteOrderDisc.deleteId}
        onConfirmation={(id) => archiveHandler(true, id)}
        content={"You want to delete this order"}
      />

      {/* //modal to change the status of the order */}
      <DeleteModal
        w="380px"
        open={changeStatusDisc.opened}
        onClose={changeStatusDisc.close}
        id={changeStatusDisc.data?.patientOrderId}
        onConfirmation={(uuid) =>
          changeStatusHandler(uuid, changeStatusDisc.data?.status).then(
            (res) => {
              showSnackbar(getSuccessSnackbar(res?.data?.message));
              return res;
            }
          )
        }
        content={`You want to change the status of this order to ${changeStatusDisc.data?.status}`}
      />

      <ShowMoreDrawer
        disclosureHost={showMoreDocDisc}
        previewResultDisc={previewResultDisc}
      />

      <UpsertLabRequisitionForm disclosureHost={orderDisc} />

      <PdfViewDrawer
        w="65vw"
        file={previewResultDisc?.data}
        disclosureHost={previewResultDisc}
        title="Order Result"
      />

      <ChartTableWrapper>
        <CustomDataGridV2
          getRowId={(row) => row?.uuid}
          rows={orders?.content ?? []}
          rowCount={orders?.page?.totalElements ?? 10}
          columns={filterActionCol(COLUMNS, isVisitNotePage)}
          rowHeight={50}
          sx={{ marginTop: "40px" }}
          disableRowSelectionOnClick
          paginationModel={pagination}
          onPaginationModelChange={setPagination}
          onSortModelChange={setGridSorting}
        />
      </ChartTableWrapper>
    </>
  );
};

export default PatientOrderNewHealthV2;

const ShowMoreDrawer = ({
  disclosureHost,
  previewResultDisc,
}: {
  disclosureHost: DisclosureHost;
  previewResultDisc: DisclosureHost;
}) => (
  <StyledDialog
    open={disclosureHost.opened}
    onClose={disclosureHost.close}
    dialogTitle="All Results"
  >
    <Flex flexDirection={"column"} gap={1} width={"30vw"}>
      {disclosureHost?.data?.map((it: any) => (
        <Flex
          alignItems={"center"}
          width={"100%"}
          justifyContent={"space-between"}
        >
          <Text
            sx={{ cursor: "pointer" }}
            color={"primary.main"}
            onClick={() => previewResultDisc.open(it?.labDocument)}
          >
            {it?.labDescription}
          </Text>
          <Button
            variant="contained"
            onClick={() => previewResultDisc.open(it?.labDocument)}
          >
            View
          </Button>
        </Flex>
      ))}
    </Flex>
  </StyledDialog>
);
